import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import '../styles/CustomerForm.css';

const EditCustomerForm = ({ customer, onCustomerUpdated, onCancel, isSeller }) => {
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    cus_name: customer.cus_name || '',
    cus_rfc: customer.cus_rfc || '',
    cus_domicilio: customer.cus_domicilio || '',
    cus_zipcode: customer.cus_zipcode || '',
    regimenfiscal_id: customer.regimenfiscal_id || '',
    cus_email: customer.cus_email || '',
    cus_phone: customer.cus_phone || ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [regimenesFiscales, setRegimenesFiscales] = useState([]);
  const [loadingRegimenes, setLoadingRegimenes] = useState(true);

  useEffect(() => {
    const fetchRegimenesFiscales = async () => {
      try {
        setLoadingRegimenes(true);
        const token = localStorage.getItem('token');
        
        if (!token) {
          setError('No se encontró un token de autenticación. Por favor, inicie sesión nuevamente.');
          return;
        }

        const response = await axios.get('/api/customers/regimenes-fiscales', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        setRegimenesFiscales(response.data);
      } catch (error) {
        console.error('Error al obtener regímenes fiscales:', error);
        setError('Error al cargar los regímenes fiscales. Por favor, inténtelo de nuevo.');
      } finally {
        setLoadingRegimenes(false);
      }
    };

    fetchRegimenesFiscales();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        setError('No se encontró un token de autenticación. Por favor, inicie sesión nuevamente.');
        return;
      }

      // Validar campos requeridos
      if (!formData.cus_name || !formData.regimenfiscal_id) {
        setError('El nombre/razón social y el régimen fiscal son obligatorios');
        setLoading(false);
        return;
      }

      // Usar endpoint diferente según el rol del usuario
      let endpoint;
      if (isSeller) {
        endpoint = `/api/customers/seller/${customer.id}`;
      } else if (user?.role === 'manager') {
        endpoint = `/api/supervisors/customers/${customer.id}`;
      } else {
        endpoint = `/api/customers/${customer.id}`;
      }

      console.log('EditCustomerForm: User role:', user?.role);
      console.log('EditCustomerForm: Using endpoint:', endpoint);

      await axios.put(endpoint, formData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      // Notificar al componente padre
      onCustomerUpdated();
    } catch (error) {
      console.error('Error al actualizar cliente:', error);
      setError(error.response?.data?.message || 'Error al actualizar el cliente. Por favor, inténtelo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="customer-form-container">
      <h3>Editar Cliente</h3>
      {error && <div className="error-message">{error}</div>}
      <form className="customer-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="cus_name">Nombre/Razón Social *</label>
          <input
            type="text"
            id="cus_name"
            name="cus_name"
            value={formData.cus_name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="cus_rfc">RFC</label>
          <input
            type="text"
            id="cus_rfc"
            name="cus_rfc"
            value={formData.cus_rfc}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="cus_domicilio">Domicilio</label>
          <textarea
            id="cus_domicilio"
            name="cus_domicilio"
            rows="3"
            value={formData.cus_domicilio}
            onChange={handleChange}
          ></textarea>
        </div>
        <div className="form-group">
          <label htmlFor="cus_zipcode">Código Postal</label>
          <input
            type="text"
            id="cus_zipcode"
            name="cus_zipcode"
            value={formData.cus_zipcode}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="regimenfiscal_id">Régimen Fiscal *</label>
          <select
            id="regimenfiscal_id"
            name="regimenfiscal_id"
            value={formData.regimenfiscal_id}
            onChange={handleChange}
            required
            disabled={loadingRegimenes}
          >
            <option value="">Seleccione un régimen fiscal</option>
            {regimenesFiscales.map(regimen => (
              <option key={regimen.id} value={regimen.id}>
                {regimen.rf_codigo} - {regimen.rf_nombreregimen}
              </option>
            ))}
          </select>
          {loadingRegimenes && <div className="loading-indicator">Cargando regímenes fiscales...</div>}
        </div>
        <div className="form-group">
          <label htmlFor="cus_email">Email</label>
          <input
            type="email"
            id="cus_email"
            name="cus_email"
            value={formData.cus_email}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="cus_phone">Teléfono</label>
          <input
            type="tel"
            id="cus_phone"
            name="cus_phone"
            value={formData.cus_phone}
            onChange={handleChange}
          />
        </div>
        <div className="form-buttons">
          <button type="button" className="cancel-btn" onClick={onCancel} disabled={loading}>
            Cancelar
          </button>
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Guardando cambios...' : 'Guardar Cambios'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditCustomerForm;
